import { Body, Controller, Get, Param, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { RequestService } from "./request.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { RequestDto } from "./dto/request.dto";
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { RequestById } from "./dto/request.request";
import { RequestReport } from "./dto/request.report";
import { VisitorDto } from "./dto/security.dto";
import { RequestByName } from "./dto/request.name";

@ApiTags('Requestform')
@Controller('request')

export class RequestController {
    constructor(
        private requestService: RequestService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ){}

    @Post('/createRequest')
    async createRequest(@Body() requestDto: RequestDto): Promise<CommonResponse> {
        try{
            return await this.requestService.createRequest(requestDto);
        }
        catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getAllRequests')
    async getAllRequests(): Promise<CommonResponse> {
        try{
            return await this.requestService.getAllRequests();
        }
        catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/updateStatusHod')
    async updateStatusHod(@Body() req: RequestDto): Promise<GlobalResponseObject> {
        try{
            return await this.requestService.updateStatusHod(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(GlobalResponseObject, error)
        }
    }

    @Post('/getHodApprovedRequests')
    async getHodApprovedRequests(@Body() req:RequestReport): Promise<CommonResponse> {
        console.log(req,"req")
        try{
            return await this.requestService.getHodApprovedRequests(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/updateStatusHr')
    async updateStatusHr(@Body() req: RequestDto): Promise<GlobalResponseObject> {
        try{
            return await this.requestService.updateStatusHr(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(GlobalResponseObject, error)
        }
    }

    @Get(':id')
    async getPassById(@Param('id') id): Promise<CommonResponse> {
        try{
            const reqId = new RequestById();
            reqId.requestId = id;
            console.log(id)
            return await this.requestService.getById(reqId);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getRequestById')
    async getRequestById(): Promise<CommonResponse> {
        try{
            return await this.requestService.getRequestById();
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    // @Post('/getById')
    // async getById(@Body() req: RequestById): Promise<CommonResponse> {
    //     try {
    //         return await this.requestService.getById(req);
    //     } catch(error) {
    //         return this.applicationExceptionhandler.returnException(CommonResponse,error)
    //     }
    // }
    @Post('/getById')
    async getById(@Body() req:RequestById ): Promise<CommonResponse> {
        try {
            return await this.requestService.getById(req);
        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getRequestByName')
    async getRequestByName(@Body() req: RequestDto): Promise<CommonResponse> {
        try{
            return await this.requestService.getRequestByName(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/updateRequest')
    async updateRequest(@Body() req: RequestDto): Promise<GlobalResponseObject> {
        try {
            return await this.requestService.updateRequest(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(GlobalResponseObject, error);
        }
    }

    @Post('/getReport')
    async getReport(@Body() req: RequestReport): Promise<CommonResponse> {
        try {
            return await this.requestService.getReport(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error);
        }
    }

    @Post('/createCheckIn')
    async createCheckIn(@Body() requestDto: VisitorDto): Promise<GlobalResponseObject> {
        try{
            return await this.requestService.createCheckIn(requestDto);
        }
        catch(error){
            return this.applicationExceptionhandler.returnException(GlobalResponseObject,error)
        }
    }

    @Post('/updateCheckOut')
    async updateCheckOut(@Body() req: VisitorDto): Promise<GlobalResponseObject> {
        try {
            return await this.requestService.updateCheckOut(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(GlobalResponseObject, error);
        }
    }

    @Post('/getAllCheckIn')
    async getAllCheckIn(@Body() req: RequestById): Promise<CommonResponse> {
        try{
            return await this.requestService.getAllCheckIn(req);
        }
        catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getAllCheckInReport')
    async getAllCheckInReport(): Promise<CommonResponse> {
        try{
            return await this.requestService.getAllCheckInReport();
        }
        catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getReqIdPreviewData')
    async getReqIdPreviewData(@Body() req:RequestById ): Promise<CommonResponse> {
        try {
            return await this.requestService.getReqIdPreviewData(req);
        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getExpiredRequests')
    async getExpiredRequests(): Promise<CommonResponse> {
        try {
            return await this.requestService.getExpiredRequests();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getExpiredRequestsHr')
    async getExpiredRequestsHr(): Promise<CommonResponse> {
        try {
            return await this.requestService.getExpiredRequestsHr();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/searchByName')
    async searchByName(@Body() req:RequestByName): Promise<CommonResponse> {
        console.log(req,"request")
        try {
            return await this.requestService.searchByName(req);
        }catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getByDate')
    async getByDate(@Body() req:RequestReport): Promise<CommonResponse> {
        try {
            return await this.requestService.getByDate(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error);
        }
    }

    @Post('/visitorCount')
    async visitorCount(): Promise<CommonResponse> {
        try {
            return await this.requestService.visitorCount();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/todayVisitors')
    async todayVisitors(): Promise<CommonResponse> {
        try {
            return await this.requestService.todayVisitors();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/todayRequests')
    async todayRequests(): Promise<CommonResponse> {
        try {
            return await this.requestService.todayRequests();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/hodCount')
    async hodCount(): Promise<CommonResponse> {
        try {
            return await this.requestService.hodCount();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/hrCount')
    async hrCount(): Promise<CommonResponse> {
        try {
            return await this.requestService.hrCount();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }

    @Post('/visitorMonthWiseCount')
    async visitorMonthWiseCount(): Promise<CommonResponse> {
        try {
            return await this.requestService.visitorMonthWiseCount();

        } catch(error){
            return this.applicationExceptionhandler.returnException(CommonResponse,error)
        }
    }
    

    @Post('/getDateReport')
    async getDateReport(@Body() req:RequestReport): Promise<CommonResponse> {
        try {
            return await this.requestService.getDateReport(req);
        } catch(error) {
            return this.applicationExceptionhandler.returnException(CommonResponse,error);
        }
    }
}